/*
 * The access token lives in module memory, never in localStorage — a token in
 * storage is readable by any script that gets injected into the page. The
 * long-lived half of the session is the httpOnly refresh cookie the API sets,
 * which JavaScript cannot read at all; a hard reload recovers the access token
 * by calling `/auth/refresh` against that cookie.
 */

let accessToken: string | null = null

export const getAccessToken = (): string | null => accessToken

export const setAccessToken = (token: string | null): void => {
  accessToken = token
}

export const clearAccessToken = (): void => {
  accessToken = null
}
